import styles from './UsageBar.module.css';

interface UsageBarProps {
	label: string;
	used: number;
	max: number;
	hint?: string;
	variant?: 'token' | 'quota';
}

const formatCount = (value: number) => value.toLocaleString('pt-BR');

export const UsageBar = ({ label, used, max, hint, variant = 'quota' }: UsageBarProps) => {
	const safeMax = Math.max(max, 0);
	const percent = safeMax > 0 ? Math.min(100, Math.max(0, (used / safeMax) * 100)) : 0;

	return (
		<div className={styles.row}>
			<div className={styles.header}>
				<div className={styles.labelWrap}>
					<span className={styles.label}>{label}</span>
					{hint ? <span className={styles.hint}>{hint}</span> : null}
				</div>
				<p className={styles.counts}>
					<span className={styles.used}>{formatCount(used)}</span>
					<span className={styles.max}> de {formatCount(safeMax)}</span>
				</p>
			</div>
			<div className={styles.track} aria-hidden="true">
				<span
					className={`${styles.fill} ${variant === 'token' ? styles.token : styles.quota}`}
					style={{ width: `${percent}%` }}
				/>
			</div>
		</div>
	);
};
